module.exports = __webpack_public_path__ + "static/img/blekey-1.19dada0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/blekey/key1/blekey-1.png
// module id = sjWF
// module chunks = 0